'use client';

import queryString from 'query-string';
// This hook is intended for use in Next.js environment only
// and there is a legacy counterpart for this as well
// eslint-disable-next-line import/no-unresolved
import { useRouter, usePathname, useSearchParams } from 'next/navigation';
import { useMemo } from 'react';
import { debounce } from 'lodash';
import { ALGOLIA_INDEX_NAME, DEFAULT_SORT_ORDER } from 'commons/constants';

const useAdvancedSearchNextURL = () => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const queryUrlParam = searchParams?.get('q') ?? '';
  const categoryUrlParam =
    searchParams?.get('category') ?? ALGOLIA_INDEX_NAME.PRODUCTS;
  const sortByUrlParam = searchParams?.get('sortBy') ?? DEFAULT_SORT_ORDER;

  const updateUrlParam = useMemo(
    () =>
      debounce(updates => {
        if (updates) {
          // Build current params object
          const updatedUrlParams = queryString.stringify({
            ...Object.fromEntries(searchParams),
            ...updates,
          });

          // Use router.replace for Next.js navigation
          const newPath = `${pathname}${
            !pathname.endsWith('/') ? '/' : ''
          }?${updatedUrlParams}`;
          router.replace(newPath, { scroll: false });
        }
      }, 300),
    [router, pathname, searchParams]
  );

  return {
    queryUrlParam,
    categoryUrlParam,
    sortByUrlParam,
    updateUrlParam,
  };
};

export default useAdvancedSearchNextURL;
